<template>
  <div id="data-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Number" v-model="data_local.number" type="number" v-validate="'required'" name="number" />
        <span class="text-danger text-sm"  v-show="errors.has('number')">{{ errors.first('number') }}</span>

        <div class="mt-4">
          <label class="vs-input--label">Property*</label>
          <v-select :options="optionProperty" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.building_id" name="building_id" class="inputx" disabled/>
          <span class="text-danger text-sm"  v-show="errors.has('building_id')">{{ errors.first('building_id') }}</span>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Unit Square Feet" v-model="data_local.unit_square_feet" type="unit_square_feet" v-validate="'required'" name="unit_square_feet" />
        <span class="text-danger text-sm"  v-show="errors.has('unit_square_feet')">{{ errors.first('unit_square_feet') }}</span>

        <vs-input class="w-full mt-4" label="HOA Fee" v-model="data_local.hoa_fee" type="hoa_fee" v-validate="'required'" name="hoa_fee" />
        <span class="text-danger text-sm"  v-show="errors.has('hoa_fee')">{{ errors.first('hoa_fee') }}</span>

        <vs-input class="w-full mt-4" label="Parking Stall Number" v-model="data_local.parking_stall_number" type="parking_stall_number" v-validate="'required'" name="parking_stall_number" />
        <span class="text-danger text-sm"  v-show="errors.has('parking_stall_number')">{{ errors.first('hoa_fee') }}</span>
      </div>      

    </div>
    
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="submit" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      token: localStorage.usertoken,

      optionProperty: [],

      //unit
      data_local: {
        number: null,
        building_id: null,
        unit_square_feet: '',
        hoa_fee: '',
        parking_stall_number: '',
        wine_locker_number: '',
        storage_unit_number: '',
        surfboard_storage: '',
        bike_storage: '',
        kayak_storage_number: '',
        boat_storage_number: '',
        unit_status_id: 0,
        is_high_security: 0,
        high_security_note: '',
        votes_pci: '',
        maint_fee: '',
        reserve_fee: '',
        rec_fee: ''
      },

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ],

      // uploading docs
      files: [],
      rawFiles: [],
      resDataLocal: [],
      resUp: [],
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    deleteImage(k) {
      // document.getElementById(f).style.display = 'none';
      this.$delete(this.files, k)
      this.$delete(this.rawFiles, k)

      console.log('this.files ', this.files)
      console.log('this.rawFiles ', this.rawFiles)

      this.$vs.notify({
        color: 'success',
        title: 'Deleting Data',
        text: 'File deleted'
      })
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    submit() {
      this.$validator.validateAll()
      .then(result => {
        if(result) {
          this.save_changes()
        }
      })
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      this.data_local.property_ref = localStorage.selectedParentOrgRef

      const editId = -1
      new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/unit/save/${editId}`, {
              data: this.data_local,
              token: this.token
            })
            .then(res => {    
              if(res['data'] != 'access_denied' && res['data'] != '') {

                //uploading docs
                if(res['data']['message'] == 'success') {
                  //uploading docs
                  this.resDataLocal = res['data']['result']

                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully saved'
                  })

                  // this.$router.push({name:'app-unit-list'})
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-unit-list'})
              }

            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            }) 

            // uploading docs
            // await axios.post(`/docs/table/save`, {
            //   rawFiles: this.rawFiles,
            //   token: this.token,
            //   id: this.resDataLocal.id,
            //   path: `docs/unit/gallery/${this.resDataLocal.id}`,
            //   folderId: 30
            // })

            this.$router.push({name:'app-unit-list'})
        } catch(err) {
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      //unit
      this.data_local['message'] = ''
      this.data_local['property_ref'] = ''
      this.data_local['title'] = ''
      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    //uploading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    //uploading docs
    async update_avatar () {
      this.$vs.loading()
      var formdata = new FormData();
      $.each($('#fileD')[0].files, function(i, file) {
        formdata.append('fileD_'+i, file);
      });
      formdata.append('token', this.token)

      this.resUp = await axios.post(`/docs/upload`,  
        formdata, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }
      )

      for (const [key, value] of Object.entries(this.resUp.data.rawD)) {
        var imgB64 = this._arrayBufferToBase64( value.data.data )
        var imgAsc = imgB64.toString('ascii')
        this.files.push("data:image/png;base64, " + imgAsc)
      }

      if (this.resUp.data.uploadedD.length > 1) {
        for (const [key, value] of Object.entries(this.resUp.data.uploadedD)) {
          this.rawFiles.push(value)
        }
      } else {
        this.rawFiles[0] = this.resUp.data.uploadedD
      }

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    },
    async loadProperty () {
      var d = await axios.get('/property/list', {
        headers: { 
          'Authorization': localStorage.usertoken
        },
      })

      this.optionProperty = d['data']

      this.optionProperty.filter((res) => {
        this.data_local.building_id = localStorage.selectedParentOrgRef == res['ref'] ? res['id'] : this.data_local.building_id
      })

      console.log('this.optionProperty  ', this.optionProperty)
    },    
  },
  async created () {
    this.loadProperty()
  }
}
</script>
